import { render, staticRenderFns } from "./collectDetail.vue?vue&type=template&id=4697638d&scoped=true"
import script from "./collectDetail.vue?vue&type=script&lang=js"
export * from "./collectDetail.vue?vue&type=script&lang=js"
import style0 from "./collectDetail.vue?vue&type=style&index=0&id=4697638d&lang=scss"
import style1 from "./collectDetail.vue?vue&type=style&index=1&id=4697638d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4697638d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\App_php\\cqjtdx\\cqjtdx_student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4697638d')) {
      api.createRecord('4697638d', component.options)
    } else {
      api.reload('4697638d', component.options)
    }
    module.hot.accept("./collectDetail.vue?vue&type=template&id=4697638d&scoped=true", function () {
      api.rerender('4697638d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/record/calssModule/collectDetail.vue"
export default component.exports